<template>
  <div 
    id="g-recaptcha"
    class="g-recaptcha"
    :data-sitekey="sitekey"
  >
  </div>
</template>

<script>
export default {
  data () {
    return {
      sitekey: "6LeAw9EUAAAAAJhmVAChHUDh7AuetcD_Mh2QY9RS",
      widgetId: 0,
      captchaReady: false,
      checkingInterval: null
    }
  },
  created() {
    let self = this;
    this.checkingInterval = setInterval(function() {
      if (window.grecaptcha && window.grecaptcha.render) {
        self.captchaReady = true;
      }
    }, 500); //or whatever interval you want to check...
  },
  watch: {
    captchaReady(data) {
      if (data) { 
        clearInterval(this.checkingInterval); 
        this.render();
      }
    }
  },
  methods: {
    execute() {
      if (this.captchaReady) {
        window.grecaptcha.render(this.widgetId);
      }
    },
    reset() {
      if (this.captchaReady) {
        window.grecaptcha.reset(this.widgetId);
        // While resetting, let's expire the Captcha Token as well!
        this.captchaExpired();
      }
    },
    captchaExpired() {
      this.$store.dispatch("setCaptchaToken", null);
    },
    render() {
      if (this.captchaReady) {
        this.widgetId = window.grecaptcha.render('g-recaptcha', {
          sitekey: this.sitekey,
          'expired-callback': this.captchaExpired,
          // the callback executed when the user solve the recaptcha
          callback: (response) => {
            // emit an event called verify with the response as payload
            this.$emit('verify', response);
          }
        });
      }
    }
  },
  mounted () {
    // render the recaptcha widget when the component is mounted
    this.render()
  }
}
</script>